import { useMutation } from "@tanstack/react-query";
import { downloadService } from "@/services/downloadService";

export type DownloadParams = {
  downloadUrl: string;
  fileName: string;

  payload?: any;
  method?: "GET" | "POST";

  metadata?: Record<string, any>;
};

export type UseDownloadMutationOptions = {
  onSuccess?: (variables: DownloadParams) => void;
  onError?: (error: Error, variables: DownloadParams) => void;
};

export const useDownloadMutation = (options?: UseDownloadMutationOptions) => {
  const downloadMutation = useMutation({
    mutationFn: async ({
      downloadUrl,
      fileName,
      payload,
      method = "POST",
    }: DownloadParams) => {
      if (method === "GET") {
        await downloadService.downloadApiFileWithGET(downloadUrl, fileName);
      } else {
        await downloadService.downloadApiFileWithPOST(
          downloadUrl,
          fileName,
          payload,
        );
      }
      return { fileName };
    },
    onSuccess: (_data, variables) => {
      options?.onSuccess?.(variables);
    },
    onError: (error: Error, variables) => {
      console.error("Download failed:", error);
      options?.onError?.(error, variables);
    },
  });

  return {
    download: downloadMutation.mutate,
    downloadAsync: downloadMutation.mutateAsync,
    isDownloading: downloadMutation.isPending,
  };
};
